import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import Img from './Img'
import imageArrayToImgContent from '../utilities/Data/imageArrayToImgContent'
import styles from './ItemGrid.icss'
import Icon from './Icon'

class ItemGrid extends React.Component {
	render() {
		const { classes, isLoading, itemsAcross, iconName, itemFragment, renderAfterItem, imageContent, imageCover, fitScoreTesting, imageClassName, onContextClick, ...otherProps } = this.props // eslint-disable-line react/prop-types
		const { showFollow, follow, followSet, showOwnWant, own, want, ownSet, wantSet, showCountComments, countComments, countCommentsClick, shareClick, kudos, showKudos, kudosSet, kudosCount, ...anchorProps } = otherProps
		anchorProps.href = (anchorProps.onClick && !anchorProps.href ? 'javascript:void()' : anchorProps.href) || '#' // eslint-disable-line no-script-url
		const images = imageArrayToImgContent(imageContent)
		return (
			// TODO: maybe make this not an anchor as the parent, this component should prevent default, others don't need to know it's an anchor
			// TODO: maybe stop pushing (all) other props on to the anchors directly... so the user does not need to know it's an anchor...
			<div className={classNames(styles[`item${itemsAcross}`], classes.root, { [styles.isLoading]: isLoading })}>
				{itemFragment || (
					<React.Fragment>
						<Link to={anchorProps.href} {...anchorProps}>
							<div className={styles.itemHeight}>
								<Img className={classNames(styles.img, styles.itemContent, imageClassName, (imageCover ? styles.cover : null))} content={images} divisor={itemsAcross} />
								{iconName && <Icon name={iconName} className={styles[`itemTypeIcon${itemsAcross}`]} />}
							</div>
						</Link>
					</React.Fragment>
				)}
				{renderAfterItem && renderAfterItem}
			</div>
		)
	}
}

ItemGrid.propTypes = {
	classes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	imageContent: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string })),
		PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string })))
	]),
	imageCover: PropTypes.bool,
	imageClassName: PropTypes.string,
	isLoading: PropTypes.bool,
	itemFragment: PropTypes.node,
	renderAfterItem: PropTypes.node,
	itemsAcross: PropTypes.number,
	iconName: PropTypes.string,
	onContextClick: PropTypes.func
}

ItemGrid.defaultProps = {
	classes: {},
	imageContent: [{ url: '/images/placeholder.png' }],
	imageCover: true,
	imageClassName: undefined,
	isLoading: false,
	itemFragment: undefined,
	renderAfterItem: undefined,
	itemsAcross: 3,
	iconName: undefined,
	onContextClick: undefined
}

export default ItemGrid



// WEBPACK FOOTER //
// ./src/components/ItemGrid.jsx